import baseUrl from '../../../../utils/baseUrl';
import getToken from '../../../../utils/getToken';

export default async function ConfirmPhotoCard(photoCardIds) {
  return fetch(`${baseUrl()}/admin/api/v1/photo_cards/confirm`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({
      photo_card: {
        photo_card_ids: photoCardIds
      }
    })
  });
}
